import lodash, { isEmpty } from 'lodash'
import React, { useEffect, useMemo } from 'react'
import { ReactElement } from 'react'

import {
  AsyncValidationField,
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import { useProductSettings } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'
import createValidateBarcode from './validate'

type TBarcodeProps = {
  readonly?: boolean
  hideOnReadonly?: boolean
}

const Barcode = (props: TBarcodeProps): ReactElement => {
  const { readonly, hideOnReadonly } = props

  const { barcodeUrl, isOrderEditor } = useOrderEntry()

  const { isBarcodeInputAllowed } = useProductSettings()

  const isColiBarcodeInputAllowed = useField('isColiBarcodeInputAllowed')

  const isNew = useFieldValue<boolean>('isNew')

  const [barcode, setBarcode] = useField('barcode1', { asState: true })

  const isAllowed = useMemo(
    () => isBarcodeInputAllowed || isColiBarcodeInputAllowed || isNew,
    [isBarcodeInputAllowed, isColiBarcodeInputAllowed],
  )

  useEffect(() => {
    // clear barcode if not allowed but still set
    if (!isAllowed && !lodash.isEmpty(barcode) && !isOrderEditor) {
      setBarcode(undefined)
    }
  }, [isAllowed])

  if (!isAllowed) {
    return <></>
  }

  // FIXME: https://github.com/final-form/react-final-form/issues/883
  return (
    <>
      {readonly && !hideOnReadonly && !isEmpty(barcode) && (
        <div className="text-center">
          <Label>{i18n.t('barcode', 'Barcode')}</Label>
          <h5 className="mt-2">{barcode}</h5>
        </div>
      )}
      <div hidden={readonly}>
        <div>
          <AsyncValidationField
            name="barcode1"
            label={i18n.t('barcode', 'Barcode')}
            validate={createValidateBarcode(barcodeUrl, isNew)}
            required={isNew}
          >
            <Input type="text" />
          </AsyncValidationField>
        </div>
      </div>
    </>
  )
}

export default Barcode
